import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { CreateModal } from 'modules/cost_centers/components/Resources/Employees/CreateModal'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const CostCenterPeopleCreatePage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return (
    <ResponsivePage.Body variant="fullscreen">
      <CreateModal
        onSubmit={() => navigate(navigation.settings.finance.costCenters.people.fullPath())}
        onClose={() => navigate(navigation.settings.finance.costCenters.people.fullPath())}
        backNavigation={navigation.settings.finance.costCenters.people.fullPath()}
        finishNavigation={navigation.settings.finance.costCenters.people.fullPath()}
      />
    </ResponsivePage.Body>
  )
}

export default CostCenterPeopleCreatePage
